"use client";

import { useEffect, useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import type { FaqItem } from "@/lib/faq";

export function FaqSection() {
  const [faqItems, setFaqItems] = useState<FaqItem[]>([]);

  useEffect(() => {
    void fetch("/api/faq", { cache: "no-store" }).then((response) => response.ok ? response.json() : null).then((data) => {
      if (Array.isArray(data?.faqItems)) setFaqItems(data.faqItems);
    }).catch(() => undefined);
  }, []);

  return (
    <section className="section faq-section">
      <div className="container faq-layout">
        <div className="section-heading"><p className="section-label">Questions fréquentes</p><h2>Avant de réserver</h2></div>
        <Accordion type="single" collapsible className="faq-list">
          {faqItems.map((item, index) => (
            <AccordionItem value={`faq-${index}`} key={item.question}>
              <AccordionTrigger>{item.question}</AccordionTrigger>
              <AccordionContent><p>{item.answer}</p></AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
